import NothingFound from './NothingFound';
import NoUploads from './NoUploads';
export default {
    NoUploads,
    NothingFound,
};
